import React, { createContext, useMemo, useState } from 'react';
import { POPUP_CONFIG } from 'constants/message';
import PropTypes from 'prop-types';

import {
    DEFAULT_BOOTSTRAP_DATA,
    DEFAULT_REPLIES_DATA,
    DEFAULT_PROVIDERS_DATA,
    modifyUserData,
    FILTER_NON_URGENT_OPTIONS,
} from './Config';

const AppContext = createContext();

function AppProvider({ children }) {
    const [userData, setUserData] = useState(DEFAULT_BOOTSTRAP_DATA);
    const [repliesData, setRepliesData] = useState(DEFAULT_REPLIES_DATA);
    const [wmaAllowed, setWMAAllowed] = useState(POPUP_CONFIG.NON_URGENT_ALLOWED);
    const [hidePopup, setHidePopup] = useState(true);
    const [showResetPopup, setShowResetPopup] = useState(false);
    const [showContinueButton, setShowContinueButton] = useState(true);
    const [enableContinueBtn, setEnableContinueBtn] = useState(true);
    const [showContinueBtn, setShowContinueBtn] = useState(true);
    const [linkedProviders, setLinkedProviders] = useState(
        DEFAULT_PROVIDERS_DATA
    );
    const [filterNonurgent, setFilterNonurgent] = useState(
        FILTER_NON_URGENT_OPTIONS
    );
    const [ivrEndModuleInfo, setIVREndModuleInfo] = useState({});
    const [initialAccessToken, setInitialAccessToken] = useState(null);
    const updateUserData = newData => {
        setUserData(prevData => ({ ...prevData, ...newData }));
    };

    const setNewUserData = ({ call_detail, template, partner, ...rest }) => {
        updateUserData({
            phoneNumber: call_detail?.callback_number || '',
            call_detail,
            template,
            partner,
            ...rest,
        });

        const templateItems = template?.content?.items || [];
        modifyUserData(templateItems, updateUserData);
    };

    const contextValue = useMemo(
        () => ({
            userData,
            updateUserData,
            setNewUserData,
            repliesData,
            setRepliesData,
            linkedProviders,
            setLinkedProviders,
            filterNonurgent,
            setFilterNonurgent,
            ivrEndModuleInfo,
            setIVREndModuleInfo,
            initialAccessToken,
            setInitialAccessToken,
            wmaAllowed,
            setWMAAllowed,
            hidePopup,
            setHidePopup,
            showResetPopup,
            setShowResetPopup,
            showContinueButton,
            setShowContinueButton,
            enableContinueBtn,
            setEnableContinueBtn,
            showContinueBtn,
            setShowContinueBtn,
        }),
        [
            userData,
            updateUserData,
            setNewUserData,
            repliesData,
            setRepliesData,
            linkedProviders,
            setLinkedProviders,
            filterNonurgent,
            setFilterNonurgent,
            ivrEndModuleInfo,
            setIVREndModuleInfo,
            initialAccessToken,
            setInitialAccessToken,
            wmaAllowed,
            setWMAAllowed,
            hidePopup,
            setHidePopup,
            showResetPopup,
            setShowResetPopup,
            showContinueButton,
            setShowContinueButton,
            enableContinueBtn,
            setEnableContinueBtn,
            showContinueBtn,
            setShowContinueBtn,
        ]
    );

    return (
        <AppContext.Provider value={contextValue}>
            {children}
        </AppContext.Provider>
    );
}

AppProvider.propTypes = {
    children: PropTypes.node,
};

AppProvider.defaultProps = {
    children: null,
};

export { AppProvider, AppContext };
